module.exports = __webpack_public_path__ + "static/img/nawiKoniec-ON.e7f61919.png";